var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullScreen"},[_c('iframe',{ref:"pdfViewerBody",staticClass:"fullScreen",attrs:{"src":"/pdfvw/pdfviewer.html","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }